import { render, staticRenderFns } from "./PostEditor.vue?vue&type=template&id=7a6fbcc4&scoped=true"
import script from "./PostEditor.vue?vue&type=script&lang=js"
export * from "./PostEditor.vue?vue&type=script&lang=js"
import style0 from "./PostEditor.vue?vue&type=style&index=0&id=7a6fbcc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6fbcc4",
  null
  
)

export default component.exports